// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.58.0',
  commit: '1d1beb0096551b99c9a1f01e6b403a085339039d',
  branch: 'feature/APA-3874-keycloack',
  dateGenerated: '2026-01-22T17:40:38.946Z',
};